<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-03-07 13:34:36
-->
<template>
  <!-- 养成 -->
  <drug></drug>
</template>

<script>
import drug from "../ym-drug/ym-drug.vue";
export default {
  name: "yc-drug",
  data() {
    return {};
  },
  computed: {},
  methods: {},
  components: { drug },
  created() {},
};
</script>

<style lang="less" scoped>
</style>